function SchoolService() {
    const school = this;
    school.formdata = {};
}
SchoolService.$inject = [];
export default SchoolService;
